import React,{useState} from 'react';

export default function PassengerCard({ passenger }) {
  const [open, setOpen] = useState(false);
  return (
    <>

    <div className="passenger-card">
      <div onClick={() => setOpen(!open)} className="passenger-header flexRow justifyContentSpaceBetween width100">
        <div className='flexCol justifyContentFlexStart'>
          <strong>{passenger.name}</strong>
          <p>
            Seat: {passenger.seat} | {passenger.pnr} | {passenger.ssr}
          </p>
        </div>
        <div className='flexCol alignItemsCenter justifyContentCenter'>
          <p>{passenger.crew}</p>
          <small>{passenger.pos}</small>

        </div>
         <div className='flexRow'>
           <p>
            {passenger.payment}
          </p>

        </div>
               <div className='flexRow justifyContentFlexEnd'>
           <p>
            {passenger.amount}
          </p>

        </div>


      </div>
      {open && passenger.items.length > 0 && (
        <ul className="items">
          {passenger.items.map((item, i) => (
            typeof item === 'object' && item.itemName && item.quantity && item.totalAmountInUsedCurrency ? (
              <li key={i} className='justifyContentSpaceBetween flexRow width100'>
                <span className='flexRow justifyContentFlexStart'>{item.itemName}&nbsp;(Qty:{item.quantity})</span>
                <span className='flexRow justifyContentFlexEnd'>€{item.totalAmountInUsedCurrency}</span>
              </li>
            ) : (
              <li key={i} className='justifyContentSpaceBetween flexRow width100'>
                <span className='flexRow justifyContentFlexStart'>Invalid item</span>
              </li>
            )
          ))}
        </ul>
      )}
    </div>
    </>
  );
}